"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Operation = /** @class */ (function () {
    function Operation(name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!name) {
            throw new Error('Missing operation name');
        }
        this.name = name;
        this.args = args;
    }
    return Operation;
}());
exports.default = Operation;
//# sourceMappingURL=operation.js.map